import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Button, Box, Modal } from "@mui/material";
import DataTable from "react-data-table-component";
import sh from "bundles/common/utils/sh";
import ConfirmModal from "bundles/Internal/components/ConfirmModal";
import { capitalize } from "bundles/common/utils/helpers";
import EditRegionalDepartmentModal from "./EditRegionalDepartmentModal";

const RegionalDepartmentsIndex = ({ departments, regionalDepartments, fetchAllRegionalDepartments }) => {
  const currentUser = useSelector((state) => state.current_user);
  const authenticityToken = useSelector((state) => state.authenticity_token);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [selectedRegionalDepartment, setSelectedRegionalDepartment] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const columns = [
    {
      name: "Name",
      selector: row => row.name,
      sortable: true,
      grow: 1,
    },
    {
      name: "Email",
      selector: row => row.email,
      sortable: true,
      grow: 2,
    },
    {
      name: "Department",
      selector: row => row.department.name,
      sortable: true,
      grow: 1,
    },
    {
      name: "Region",
      selector: row => capitalize(row.region),
      sortable: true,
      grow: 1,
    },
    // {
    //   name: "",
    //   selector: row => {
    //     return (<Box>
    //       <Button
    //         size="small"
    //         variant="text"
    //         onClick={() => editRegionalDepartment(row)}
    //       >
    //         Edit
    //       </Button>
    //       <Button
    //         size="small"
    //         variant="text"
    //         disabled={loading}
    //         onClick={() => deleteRegionalDepartment(row)}
    //       >
    //         Delete
    //       </Button>
    //     </Box>);
    //   },
    //   sortable: true,
    //   width: "160px"
    // },
  ];

  const redirectUnauthorizedUsed = () => {
    navigate("/internal");
  };

  const createRegionalDepartment = () => {
    editRegionalDepartment(null);
  };

  const editRegionalDepartment = (regionalDepartment) => {
    setSelectedRegionalDepartment(regionalDepartment);
    setIsEditModalOpen(true);
  };

  const deleteRegionalDepartment = (regionalDepartment) => {
    setSelectedRegionalDepartment(regionalDepartment);
    setIsConfirmModalOpen(true);
  };

  const handleDeleteConfirmed = () => {
    setLoading(true);
    sh.delete("internal/regional_departments", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        authenticity_token: authenticityToken,
        regional_department: { id: selectedRegionalDepartment?.id }
      },
    }).then(() => {
      fetchAllRegionalDepartments();
      setSelectedRegionalDepartment(null);
      enqueueSnackbar("Regional department successfully deleted!", {
        variant: "success",
      });
    }).catch((error) => {
      let errorMessage = "Oops, an error occurred.";

      if (error?.response?.status === 401) {
        errorMessage = "You need admin privileges to delete regional departments.";
      } else if (error?.response?.status === 403) {
        errorMessage = "Access denied. You don't have the required permissions.";
      } else if (error?.response?.status === 404) {
        errorMessage = "Regional department not found.";
      } else if (error?.response?.status === 422) {
        errorMessage = "This regional department still has active users linked to it.";
      } else if (error?.response?.status >= 500) {
        errorMessage = "Server error. Please try again later.";
      }

      enqueueSnackbar(errorMessage, { variant: "error" });
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    if (!currentUser || !currentUser["admin_or_manager?"]) {
      redirectUnauthorizedUsed();
    } else {
      fetchAllRegionalDepartments();
    }
  }, []);

  return (
    <>
      <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "16px" }}>
        <h1>Regional departments</h1>
        <Button variant="squared" color="primaryOutlined" onClick={createRegionalDepartment}>Create a new regional department</Button>
      </Box>
      <DataTable
        columns={columns}
        data={regionalDepartments}
        responsive
        striped
        highlightOnHover
        pagination
      />
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        setIsOpen={setIsConfirmModalOpen}
        handleConfirm={handleDeleteConfirmed}
        label="You're about to delete this regional department."
      />
      <Modal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EditRegionalDepartmentModal
          closeModal={() => setIsEditModalOpen(false)}
          regionalDepartment={selectedRegionalDepartment}
          departments={departments}
          fetchAllRegionalDepartments={fetchAllRegionalDepartments}
        />
      </Modal>
    </>
  );
};

export default RegionalDepartmentsIndex;
